import React from 'react';

const SportsPassFilterReset = ({SportsPassOnReset, SportsPassResetShow}) => (
	<div className="sports-pass-filter-reset" data-testid="sports-pass-filter-reset">
		{ SportsPassResetShow && (
			<button 
				type="button"
				onClick={SportsPassOnReset} 
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						SportsPassOnReset();
					}
				}}
				className="btn btn-primary btn-lg btn-pink-3 btn-show"
				aria-label="Réinitialiser tous les filtres de recherche"
				title="Réinitialiser tous les filtres de recherche"
			>
				Réinitialiser les filtres
			</button>
		) }
	</div>
)

export default SportsPassFilterReset;
